export function maskString(text: string, last: number = 4): string {
  return text.length > last
    ? `${text.substring(0, text.length - last)}****`
    : "*".repeat(text.length);
}
